import React from "react";
import { Element } from "react-scroll";

import PageWrapper from "../components/PageWrapper";
import Hero from "../sections/landing4/Hero";
import ProductsSplit from "../sections/landing4/ProductsSplit";
import Methodology from "../sections/landing4/Methodology";
import SocialProof from "../sections/landing4/SocialProof";
import Services from "../sections/landing4/Services";
import Tools from "../sections/landing4/Tools";
import CTA from "../sections/landing4/CTA";
import Seo from "../components/Seo";
import { organizationJsonLd, websiteJsonLd } from "../data/jsonld";

const IndexPage = () => {
  return (
    <>
      <Seo
        pathname="/"
        jsonLd={[organizationJsonLd, websiteJsonLd]}
      />
      <PageWrapper>
        <Hero />
        <ProductsSplit />
        <Methodology />
        <SocialProof />
        <Element name="services">
          <Services />
        </Element>
        <Element name="tools">
          <Tools />
        </Element>
        <CTA />
      </PageWrapper>
    </>
  );
};
export default IndexPage;
